"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSearchLoader = exports.StyledRow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledSearchLoader = _styledComponents.default.div.withConfig({
  displayName: "Searchstyle__StyledSearchLoader",
  componentId: "sc-1mb52kq-0"
})(["display:flex;flex-direction:column;"]);

exports.StyledSearchLoader = StyledSearchLoader;

const StyledRow = _styledComponents.default.div.withConfig({
  displayName: "Searchstyle__StyledRow",
  componentId: "sc-1mb52kq-1"
})(["display:flex;align-items:center;div:first-child{margin-right:29px;}div:last-child{margin-left:12px;}"]);

exports.StyledRow = StyledRow;